export const GOLD_PRICE = (50000).toLocaleString(navigator.language);
export const STAR_PRICE = (490000).toLocaleString(navigator.language);
export const GALAXY_PRICE = (990000).toLocaleString(navigator.language);

export const GOLD_PRICE_S = 5;
export const STAR_PRICE_S = 49;
export const GALAXY_PRICE_S = 99;
